module.exports = __webpack_public_path__ + "img/Infinity-1.2s-221px.8fb5bd69.svg";